
export {} from '@clayui/table';
import __x__ from '@clayui/table';export default __x__;